export default {
	currencies: {
		USD: "USD",
		UZS: "UZS",
		EUR: "EUR",
		GBP: "GBP",
		RUB: "RUB",
		CHF: "CHF"
	},
	langs: {
		ru: {
			title: "Русский",
			flag: "ru"
		},
		en: {
			title: "English",
			flag: "us"
		},
		uz: {
			title: "Ўзбекча",
			flag: "uz"
		}
	},
	fileExtensions: {
		PDF: "PDF",
		XLS: "XLS",
		DOC: "DOC",
		TXT: "TXT"
	},
	errors: {
		error: "Connection error",
		errorTitle: "Error",
		noMatches: 'No match found'
	},
	login: {
		viaDigitalSign: {
			comeBack: 'Go back',
			enterPassword: 'Enter the password for the EDS certificate',
			selectCompany: 'Select an organization',
			notConnected: 'The EDS module of Certification Authority is not connected',
			setupModule: 'To add an organization, you need to install the module',
			setup: 'Install',
			becomeClient: 'Become a bank customer',
			insertKey: 'Insert the EDS key',
			keyNotFound: 'The EDS key was not detected. Insert the EDS key into the USB port. If you do not have an EDS key, contact the nearest Bank branch to obtain it.',
			keyTerm: 'EDS validity period',
			left: 'remained',
			enterSmsCode: 'Enter the code from the SMS',
			sessionFinished: 'The session is over',
			sessionExpiredDetails: 'You have not been active for {0} minutes, the session was interrupted for security reasons. You can sign in again',
			reSignIn: 'Log in again',
			backToCompanyList: 'Go back',
			yourAccount: 'Your account',
			quickAccess: 'Quick Access setting',
			enableSms: 'Enabling SMS code to confirm login',
			disableSms: 'Disabling the SMS code to confirm login',
			confirmationSms: 'SMS code to confirm login',
			smsDisablingDetails: 'When disabling the function, you do not need to confirm the login with a one-time SMS code',
			day: 'day',
			days: 'days',
			moreDays: 'days',
			selectOS: 'Select the operating system',
			setupModuleOS: 'Install the CA EDS module on your computer',
			WINDOWS: 'Windows',
			MAC_OS: 'macOS',
			selectKeyType: 'Choose the type of key',
			howSetup: 'How to install',
			becomeClientInfin: 'Become an InfinBusiness client',
			growBusiness: 'Grow your business with us',
			becomeCustomer: 'Become a client',
			I_KEY: 'iKey',
			E_PASS: 'ePass',
			setupToComputer: 'How to install the module \nCA EDS on your computer',
			setupToOSByKeyType: 'How to install the СА EDS module on {0} \n(key type {1})',
			downloadArchive: 'Download the archive',
			downloadArchiveDescription: 'First, you need to download the archive. Then, you need to unpack the archive using an archiver. The archive contains two files: IKEY.exe and Isigner.exe.',
			setupIkeyDriver: 'Next, you need to install the IKEY driver',
			setupIkeyDriverDescription: 'It needs to be installed so that your computer can recognize the key.',
			setupProcess: 'Installation process',
			setupProcessDescription: '<ul class="simple-list"><li>During the installation process, you need to accept the driver’s license agreement by clicking “Yes”.</li><li>Also, during installation, a modal window will appear asking you to insert the flash drive key into the USB port to check the key’s compatibility with the driver. After inserting the key, the program will continue the installation.</li><li>Once the download is complete, click the “Finish” button.</li></ul>',
			execIsigner: 'Next, you need to install Isigner',
			execIsignerProblem: 'Next, you need to install Isigner',
			execIsignerProblemDescription: 'If you are unable to install the program, first right-click the file, and from the menu, select “Properties,” then check the “Unblock” box and click “OK” as shown in the screenshot.<br><br>Afterward, try installing again (if it doesn’t work, right-click the file and from the menu, select “Runas administrator”).',
			openSetuper: 'When the installer opens, click “Keyingi”',
			openSetuperDescription: 'Also, in the installation window that appears, you can check the box if you want the program to be located on your desktop.',
			clickToSetup: 'Then click the “O’rnatish” button',
			clickToReady: 'Then click the “Tayyor” button',
			clickToReadyDescription: 'You can also check the box to launch the program immediately.',
			setupCompleted: 'At this point, the installation process will be complete.',
			setupCompletedDescription: 'If you have completed all the steps, you can return to the login screen and log into your organization.',
		},
		sessionExpirationNotification: '{remainingTime} then the session will be interrupted. Take any action to prevent session interruption',
		confirmSmsCancellation: "Do you really want to cancel sms input?",
		resendSms: "The sent SMS has expired, to continue authorization you need to get a new one",
		authorization: "Login to Internet Banking",
		login: "Login",
		password: "Password",
		error: "Required field",
		errorPassword: "Must contain a lowercase symbol, uppercase letters and numbers.",
		loginOpen: "Sign in",
		forgetPassword: "Forget password?",
		howRegister: "How to become the bank’s client?",
		banner: {
			title: "Your personal <br/> mobile bank!",
			text: "All services at hand",
			btnApp: "Download the app",
			btnBrowser: "Continue via browser",
			btnUnavailable: 'Unfortunately, the web version of "Infinbusiness" is only available through a computer or laptop browser.',
		},
		help: {
			title: "Dear Customer!",
			text: "To enter, you need to contact the branch of your bank and go through the registration process.<br/>Required documents for registration:<br/>1. User identity proving document;<br/>2. Letter of attorney (original) of the organization for access to the mobile application (see below)",
			download: "Download a form",
			close: "OK"
		},
		passwordReset: {
			title: "Dear Customer!",
			text: "To restore access, you need to contact th Bank’s branch with your passport",
			close: "OK"
		},
		smsCode: {
			title: "Please enter <br/> a code from SMS",
			repeat: "Resend code"
		}
	},
	headerAuth: {
		phone: "Call center for business",
		telegram: "Telegram bot",
		department: "Branches"
	},
	howRegister: {
		headerTitle: "How to become the bank’s client",
		header: "Become a bank client",
		steps: {
			title: "Three steps and you are the bank’s client!",
			step1: "Bank representative meeting with the management of the Company",
			step2: "Providing a full package of documents for opening a bank account",
			step3: "Opening account"
		},
		btn: "More details",
		urlBranch: "https://infinbank.com/en/branches/",
		department: {
			title: "Bank branch",
			text: "Build a route to the bank"
		},
		doc: {
			title: "Documents",
			text: "Required for business registration"
		},
		tariffs: {
			title: "Term",
			text: "Check out available terms"
		},
		footer: {
			title: "Contacts",
			phone: "You can contact the bank by phone",
			email: "by email",
			text: "Visit the branch at the agreed time to open an account together with a bank specialist."
		}
	},
	tariffs: {
		header: "Terms",
		btnAllDownload: "Download all terms",
		btnAllView: "All terms",
		currentTariff: "Current terms:",
		description: "Package price",
		month: "in month",
		cost: "Free",
		commission: "Free of charge",
		download: "Download",
		titleOther: "Other applicable terms",
		debit: "Debit turnover",
		foreignCurrency: "Payments in foreign currency",
		nationalCurrency: "National currency operations",
		from: "from",
		before: "to"
	},
	doc: {
		header: "Documents",
		title: "Documents required to open a bank account",
		btnAllDownload: "Download all documents",
		download: "Download"
	},
	munis: {
		insufficientFunds: "Available balance is not sufficient",
		selectCategory: 'Select a category',
		operDayClosed: 'The process of transaction day closing is underway',
		operationsDisabled: 'Operations are temporarily unavailable',
		check: 'Check',
		btnSendToBank: 'Sign and send',
		alreadyPaid: 'The amount of the receipt to the specified number has been paid',
		paymentInfo: 'Payment details',
		continue:'Continue',
		searchText: 'Category or service name',
		nothingFound: 'Nothing found',
		maxAmountError: 'The amount should not exceed {0} UZS'
	},
	register: {
		registryOperationsText: 'Registry transactions',
		dndFileTitle: 'Select or drag a completed registry entry',
		fileFormat: 'Excel file format (.xls, .xlsx)',
		selectFile: 'Select a file',
		rules: 'Rules for filling out rows',
		downloadTemplate: 'Download the template to fill out',
		excelFile: 'Excel file',
		operDayClosed: 'The operation is temporarily unavailable. The process of closing the practice day is in progress',
		formatFileError: 'The file format must be .xls, .xlsx',
		creation: 'Create a registry practice',
		editing: 'Edit registration practice',
		uploadedFile: 'Downloaded file',
		changeFile: 'Change file',
		fileDownload: 'Download the file',
		amountOfOperations: 'Number of payment orders',
		totalAmount: 'Total amount',
		debitAccount: 'Debit account number',
		errorModalTitle: 'Failed to load registry practice',
		errorMessageTitle: 'Check that lines are filled in correctly:',
		errorCheckTableLines: 'Check that the table is filled in correctly.',
		helpText: 'We recommend that you review ',
		helpLink: 'the rules for filling rows',
		selectAccount: 'Select the debit account number',
		btnEnter: 'Enter',
		btnApprove: 'Send to director',
		btnSendToBank: 'Sign and send',
		fileChanged: 'The file has been changed',
		registerPayment: 'payment orders',
		registerPayments: 'payment orders',
		twoRegisterPayments: 'payment orders',
		downloadFile: 'Download file',
		operationStatus: 'Practice status',
		reasonPaymentRefund: 'Reason for payment return:',
		contactOurSupportTeam: 'If you have any questions or need additional information, please contact our support service.',
	},
	home: {
		questionnaire: "Questionnaire №",
		createTitlePayment: "Create a payment order",
		createNewTitlePayment: "Create a similar payment order",
		addFavoriteBills: "Add to home page",
		company: "LLC",
		titleBills: "Company’s bank account",
		textBills: "Show all",
		nameAccount: "Transit account",
		notification: {
			title: "Notification",
			text: "You have received a notification, please click to read the text",
			emptyText: "No notifications",
			openText: "Open notification"
		},
		tabsList: {
			titlePayment: "Payment order",
			recent: "Recent",
			templates: "Templates",
			btnRecent: "Show more"
		},
		statusPayment: {
			title: "Payment order status",
			inbox: "Inbox",
			outgoing: "Outgoing payments and applications",
			approval: "For approval",
			revision: "Submitted for revision",
			draft: "Drafts"
		},
		offers: "Proposals for you",
		payment: {
			title1: "Payment order",
			title2: "Anor",
			title3: "Order to budget",
			title4: "Plastic card replenishment",
			title5: "Order to the Treasury",
			title6: "Payroll",
			munis: 'MUNIS',
			register: 'Register practice',
			loanRepayment: 'Loan repayment',
			anor: 'ANOR'
		},
		organization: "Select organization",
		branch: "Select a branch",
		favoriteBills: {
			header: "Favorite accounts",
			block1: "Selected",
			block2: "Other",
			titleBlockSelect: 'Favorite'
		},
		modalPassword: {
			text: "Your password will expire in (5/4/3/2 days/1 day). For security reasons, in order to avoid unauthorized access to your account, we ask you to change your current password in advance.",
			textChange: "For security reasons, in order to avoid unauthorized access to your account, your password has expired. We kindly ask you to change your current password.",
			btnChange: "Change now",
			btnLater: "Change later"
		}
	},
	header: {
		main: "Mainpage",
		services: "Services",
		chat: "Chat",
		history: "History",
		electCommerce: "Electronic commerce",
		mfo: "Bank code:",
		in: "in"
	},
	menu: {
		closedOperDay: "Operational day closed",
		operDay: "Operational day:",
		terms: "Terms",
		employees: "Employees",
		setting: "Settings",
		branch: "Branches",
		current: "Currency rates",
		contract: "Contractors",
		support: "Support",
		signOut: "Sign out",
		appVersion: "Version"
	},
	breadcrumb: {
		title: "Main"
	},
	companyAccounts: {
		cards: {
			title: "Cards",
			btn: "Order card",
			info: {
				title: "IBCard information",
				number: "IBCard number",
				balanceCards: "IBCard balance",
				nameCard: "Debit card",
				tabInfo: "About card"
			},
			statuses: {
				active: "Card is active",
				lock: "Card blocked",
				blockClient: "Blocked by customer",
				pinLimit: "PIN code required",
				pin: "PIN code limit has been reached",
				blockBank: "Blocked by the bank"
			},
			history: {
				btnFirst: 'Income',
				btnSecond: 'Expenditure',
				print: 'Print',
				translate: 'Transferred',
				point: 'Point of payment',
				servicePoint: 'Service Point',
				terminal: 'Terminal',
				date: 'Date and time of payment',
				amountCancel: 'Withdrawal amount',
				numberTransaction: 'Transaction number'
			}
		},
		deposits: {
			title: "Deposits",
			info: {
				title: "Information about the deposit"
			},
			titleByType: {
				SAVINGS_DEPOSIT: 'Savings Deposit',
				TERM_DEPOSIT: 'Term Deposit',
			}
		},
		bills: {
			cardBlocked: "Account blocked",
			blocked: "Blocked",
			title: "Accounts",
			info: {
				title: "Account information",
				number: "Account number",
				mfo: "Bank code",
				date: "Opening date",
				dateClose: "Closing date",
				status: "Status",
				openBal: "Opening balance",
				debit: "Debit",
				credit: "Credit",
				closBal: "Closing balance",
				history: "History",
				approved: "Approved",
				opened: "Opened",
				closed: "Closed",
				balanceAccount: "Account balance",
				tabInfo: "About account"
			}
		},
		loans: {
			title: "Loans",
			header: "Credit amount",
			remaining: "Remaining",
			payment: "payments",
			titleMain: "Main amount:",
			titleAccrued: "Accrued %:",
			noPaid: "Not paid",
			paid: "Paid",
			creditPurpose: "Credit purpose",
			loanAccounts: "Loan accounts",
			nextPay: "Next payment:",
			overduePay: "Overdue payment:",
			repay: "Repay",
			schedule: "Schedule",
			creditDetails: "Credit details",
			principalDebt: "Principal debt remaining",
			accrued: "Accrued interest",
			totalCredit: "Total credit amount",
			contractTerms: "Contract terms",
			contractNumber: "Contract number",
			contractDate: "Contract date",
			interestRate: "Interest rate",
			contractEffect: "Contract is effective until",
			loanAccount: "Loan account number",
			nextPayment: "Next payment",
			tabInfo: "About loan",
			minAmount: 'The minimum loan amount (limit) is {0} UZS',
			maxAmount: 'The maximum loan amount (limit) is {0} UZS',
			history: {
				btnFirst: 'Payment',
				btnSecond: 'Disbursement',
				title: 'Credit disbursement history',
				emptyBlock: {
					title: 'No operations for the selected period',
					text: 'To display transactions, change the period'
				}
			}
		},
		replenish: {
			header: "Replenish",
			title1: "From",
			title2: "To",
			inputLabel: "Transfer amount",
			inputText: "Fee",
			card: 'Card replenishment'
		},
		transfer: "Transfer",
		modal: {
			titleUnlockCard: "Unblock card",
			textUnlockCard: "Are you sure you want to unblock the card?",
			titleLockCard: "Block card",
			textLockCard: "Are you sure you want to block the card?"
		},
		cancel: "Cancel",
		accept: "Accept",
		nameAccount: "Name of account"
	},
	createSumPayment: {
		loanRepaymentDetail: 'Loan repayment questionnaire № {0}',
		nameBank: "Name of bank",
		header: "New payment",
		treasuryMinitstry: 'Казначейство Министерства финансов Республики Узбекистан',
		aside: {
			title: "Account information",
			textField1: "Order type",
			textField2: "Document №",
			textField3: "Payment date",
			btn: "Choose from templates"
		},
		send: {
			title: "Sender",
			textField1: "Sender’s name",
			receiverName: "Name of the recipient",
			textField2: "Sender’s account number",
			senderAccount: "Recipient's account",
			textField3: "Sender’s MFO",
			receiverMFO: "Recipient's MFO",
			textField4: "Sender’s TIN",
			receiverINN: "Recipient's TIN",
			checkboxesTitle: "Transfer via ANOR",
			checkboxesText: "The Central Bank's settlement center usually works until 17:00 on weekdays. After 17:00, we recommend using transfers via ANOR. For transfers via ANOR, an additional commission is charged in accordance with the Bank's tariffs",
			checkboxesTextDisabled: "Transfer via ANOR is only available for interbank transfers"
		},
		recipient: {
			title: "Beneficiary",
			textField1: "Beneficiaryʼs name",
			clientName: "Name of the client",
			textField2: "Beneficiaryʼs account number",
			textField3: "TIN",
			textField4: "Recipient's personal account number",
			type: "Select type of recipient",
			corpCard: "Corporate card",
			dividends: "Dividends",
			other: "Others",
			cardNotFound: "Map not found",
			innField: "Enter the recipient's TIN",
			cardPhisFaces: 'Card of an individual',
			defaultText: 'Corporate card top-up'
		},
		other: {
			textField1: "Document amount",
			textField2: "Assignment code",
			textField3: "Payment details",
			textField4: "Personal account",
			textField4LabelDialog: "Search for the organization's personal account"
		},
		btn: {
			first: "Payment on contract",
			first2: "Enter",
			first3: "Approve",
			first4: "Approve on contract",
			second: "Save draft",
			third: "Save template",
			reject: "Deny"
		},
		payment: {
			title1: "Individuals",
			title2: "Import",
			title3: "Loan payment",
			title4: "Dividends",
			title5: "Inside RUz",
			title6: "Others",
			title7: "Return on export",
			title8: "Transfer of own funds"
		},
		errorMessage: "You cannot top up corporate cards belonging to another legal entity or individual entrepreneur",
		paymentAmount: "Payment amount",
		bankCommission: "Bank commission",
		additionalPay: "Additional payment details ",
		dialogSuccess: {
			title: "Sent to the bank for processing",
			user: "Your payment for {0} {1} from {2} has been successfully sent to the accountant",
			bux: "Your payment for {0} {1} from {2} has been successfully sent to the director",
			director: "Signed",
			templates: "Saved in templates",
			recipient: "Please follow the payment status in the notifications or in the \"History\" section",
			recipient3: "Follow the payment status in the notifications or in the \"History\" section",
			checkStatusLater: "The payment is being processed. Please check the status later",
			recipientAnor: "Transfers via ANOR are processed by the Bank no longer than 10 minutes. The result of the translation processing will be displayed in the \"Stories\" section\"",
			drafts: "Saved to Drafts",
			successfullySent: "Successfully sent",
			payrollBux: "Your payroll for {0} {1} from {2} has been successfully sent to the director",
			payrollEmployee: 'Your payroll for {0} {1} from {2} has been successfully sent to the accountant',
			btn: 'Ok',
			subTitle: "Sent to bank",
			recipient2: "If the transaction falls on a closed transaction day, it will be processed on the following working day. We will inform you when the transaction is processed."
		},
		dialogSuccessTitle: 'Payment order successfully sent to the bank',
		dialogErrorTitle: 'An error occurred while performing the operation',
		dialogPendingTitle: 'Payment order in standby mode',
		cardAccount: "Card account number",
		cardAccountReceiver: "Recipient's card account",
		transitAccount: "Transit account",
		numbers: "numbers",
		isAnorInfoText: "To transfer via ANOR, you need to edit the payment and specify the recipient's TIN",
		cardErrorMessage: 'The card is not active or the card with this number does not exist. Check that the card number was entered correctly',
		cardNotSupported: 'This type of card is not supported',
		error: {
			corpCard: 'You have entered the corporate card number. Do you want to top it up?',
			individualCard: 'You have entered the card number of an individual. Do you want to top it up?',
			numberAccountRecipient: 'The account number of the sender and the recipient do not belong to the same client',
			validSymbols: `The field can contain Latin letters and symbols / - ? : ( ) . , ' +`
		}
	},
	employees: {
		positionEmplyee: "Executive",
		btnFirst: "View authority role",
		btnSecond: "Delete",
		btnThird: "Block",
		btnFourth: "Unblock",
		modalLock: {
			title: "Blocking an employee",
			text: "Are you sure you want to temporarily block the employee?"
		},
		modalUnLock: {
			title: "Unblock the employee",
			text: "Are you sure you want to unblock the employee?"
		},
		modalDelete: {
			title: "Delete employee",
			text: "Are you sure you want to delete this employee profile?",
			btnCancel: "Cancel",
			btnClose: "Close"
		},
		assignRole: {
			text: "All functions are available except for signing agreements and send payments, managing the role model and cards.",
			btnText: "Learn more in the authority section",
			authority: "Authority",
			btnComplete: "Assign a role"
		},
		authority: {
			makingPayment: "Effecting payments",
			saveDraft: "Save draft",
			view: "View",
			getExtract: "Getting an extract",
			createVP: "Create purchase statement",
			downloadStatement: "Upload a statement",
			saveStatement: "Save statement (Template)",
			viewRole: "View roles/authorities",
			lock: "Blocking/Unblocking",
			delete: "Deleting",
			sendEmployee: "Enter (EDS not required)",
			sendAccountant: "Enter and confirm (EDS not required)",
			sendDirector: "Enter and submit (EDS required)",
			sendAccountantPayroll: 'Confirm (EDS not required)',
			paymentVisibility: "Payment visibility"
		}
	},
	currentDate: "Today",
	drafts: {
		header: "Drafts",
		deleteDrafts: "Delete drafts",
		deleteDraft: "Delete draft",
	},
	electCommerce: {
		header: "Electronic commerce",
		checkNumber: "Check number",
		approved: "Approved",
		declined: "Declined",
		paymentDate: "Payment date and time:",
		paymentPoint: "Payment point",
		paymentSender: "Payment sender",
		paymentName: "Payment name",
		senderCardNumber: "Senderʼs card number",
		comment: "Payment details",
		payDate: "Payment date",
		name: "Name",
		serviceId: 'Service identifier',
		categoryId: 'Service class identifier',
		serviceName: 'Service name',
		payTime: 'Time of payment',
		subscriber: 'Subscriber',
		amount: 'Amount of transfer',
		commission: 'Brokerage fee',
		systemCommission: 'System brokerage fee',
	},
	nameTemplate: "Name the template",
	savedInTemplates: "Saved in templates",
	payroll: {
		createNewTitle: 'Create, upload a statement or download a template',
		title: "Select a payment system for payroll",
		titleMin: "Choose a payment system",
		text: "To register a salary payment, add an employee to the list and enter the amount. Or upload a statement.",
		btnSelect: "Select recipient",
		btnAdd: "add statement",
		totalSum: "Total sum",
		paymentRecipient: "Payment recipients",
		employee: "employee",
		employee1: "employee",
		employee2: "employee",
		btnAddEmployee: "add employee",
		btnDeleteEmployee: "Deleting an employee",
		btnDeleteEmployeeText: "Are you sure you want to remove the employee from the payroll list?",
		btnSend: "Send to bank",
		btnUzcard: "Payment by UZCARD",
		btnHumo: "Payment by HUMO",
		createNewPayroll: {
			title: "Create payroll",
			text: "Select employees from the list and indicate the salary for each"
		},
		downloadPayroll: {
			title: "Payroll statement",
			blueText: "Select",
			text: " or transfer here an xls, xlsx file no larger than 20 MB. Before sending to the bank, you can edit it, add and remove employees.",
			textUpdate: 'Move the file to this area',
			textUpdate2: 'xls, xlsx file up to 20 Mb',
		},
		addTemplate: {
			title: "Add from template",
			text: "Select the necessary template from the previously saved"
		},
		createDownloadTemplate: {
			title: "Download payroll template",
			text: "We will form a statement from your drafts"
		},
		newPayroll: {
			yearOfLoading: 'Year of uploading',
			textAll: 'All',
			employees: 'Employees',
			swiftBankCode: 'SWIFT code of the bank ',
			withdrawalAccountNumber: 'The number of the debit account',
			enrollmentАccountNumber: 'Recipientʼs account number',
			applicationNumber: 'Application number',
			currency: "Currency",
			resetFilter: 'Reset filter',
			paymentDetails: 'Payment details',
			docDate: 'Document date',
			docNumber: "Document number",
			sheetID: "Statement ID",
			transitPayrollAccount: "Transit payroll account",
			withdrawalAccount: "Write-off account",
			header: "Creating a new statement",
			title: "Changing a recipient",
			name: "Full name of a recipient",
			nameUser: "Full name of the employee",
			score: "Recipientʼs account",
			scoreStatement: "Recipientʼs account",
			embossedName: "Recipient name embossed",
			pay: "To payoff",
			select: "Select from directory",
			btnDownload: "Download statement",
			requestDelete: "Exiting payroll creation",
			textDelete: "If you exit payroll creation, all changes will be lost",
			goOut: "Exit",
			stay: "Stay",
			sendToBank: "Send to bank",
			saveTemplates: "Save templates",
			numberStatement: "Statement №",
			status: "Status",
			dateDownload: "Date of download",
			purposePay: "Purpose of payment",
			exportStatement: "Export statement",
			amountPaid: "Amount to be paid",
			amountSelect: "Amount of selected recipients",
			paymentSystem: "Payment system",
			noSelect: "Not selected",
			searchFamilyAndAccount: 'Full name or account number of the employee',
			btnScroll: 'Go to formalization',
			copied: 'Copied',
			notCopied: 'Not copied',
			withdrawCheckBox: 'To withdraw a check box, remove the amount',
		},
		modalAttention: {
			error: "Error",
			title: "Do you already have a draft payroll?",
			text: "If you continue uploading, the draft data will be lost.",
			btnUpdate: "Go to draft",
			btn: "Continue"
		}
	},
	search: "Search",
	currencyRates: {
		header: "Currency rates",
		tabsList: {
			first: "CB",
			second: "UZCE rate",
			third: "Currency rates"
		},
		currency: "Currency",
		course: "Rate",
		buy: "Buy",
		sell: "Sell",
		change: "Changing",
		listCurrency: {
			USD: "USD",
			UZS: "Sum",
			EUR: "EURO",
			GBP: "Pound sterling",
			RUB: "Russian ruble",
			JPY: "Yen",
			QAR: "Qatari rial",
			KGS: "Kyrgyzstani som",
			IRR: "Iranian rial",
			CHF: "Swiss franc",
			UAH: "Hryvnia",
			TMT: "New Turkmen manat",
			TRY: "Turkish lira",
			TJS: "Somoni",
			THB: "Baht",
			SGD: "Singapore dollar",
			XDR: "SDR",
			SAR: "Saudi riyal",
			PKR: "Pakistani rupee",
			AZN: "Azerbaijani manat",
			MNT: "Mongolian tugpik",
			MYR: "Malaysian ringgit",
			KRW: "South Korean won",
			CAD: "Canadian dollar",
			ILS: "Israeli new shekel",
			IDR: "Rupee",
			GEL: "Georgian lari",
			VND: "Dong",
			BND: "Brunei dollar",
			BRL: "Brazilian real",
			BYN: "Belarusian ruble",
			BHD: "Bahraini dinar",
			AED: "UAE dirham",
			AFN: "Afghani",
			AMD: "Armenian dram",
			AUD: "Australian dollar",
			CNY: "Yuan",
			KWD: "Kuwaiti dinar",
			KZT: "Kazakhstani tenge",
			INR: "Indian rupee",
			HKD: "Hong Kong dollar",
			MMK: "MMK",
			KHR: "KHR",
			CUP: "CUP",
			CZK: "CZK",
			DKK: "DKK",
			HUF: "HUF",
			ISK: "ISK",
			IQD: "IQD",
			JOD: "JOD",
			LAK: "LAK",
			LBP: "LBP",
			LYD: "LYD",
			MXN: "MXN",
			MDL: "MDL",
			MAD: "MAD",
			OMR: "OMR",
			NZD: "NZD",
			NOK: "NOK",
			PHP: "PHP",
			ZAF: "ZAF",
			SEK: "SEK",
			SYP: "SYP",
			TND: "TND",
			EGP: "EGP",
			UYU: "UYU",
			YER: "YER",
			VEF: "VEF",
			SDG: "SDG",
			RSD: "RSD",
			RON: "RON",
			BYR: "BYR",
			BGN: "BGN",
			PLN: "PLN",
			DZD: "DZD",
			ARS: "ARS",
			BDT: "BDT"
		}
	},
	transfersВyАccountNumber: {
		title: "Transfers by account number",
	},
	payrollTab: {
		title: "Payroll",
	},
	swiftTransfers: {
		title: "SWIFT transfers",
	},
	currencyOperations: {
		title: 'Currency operations',
	},
	counterparties: {
		positionCounter: "Foreign",
		btnAdd: "Create a payment",
		btnHistory: "Transaction history",
		btnChange: "Change",
		title: "Details",
		name: "Contractor’s official name",
		typeActive: "Type of activity",
		country: "Country",
		titleCall: "Contacts",
		number: "Phone",
		email: "Email",
		internal: "Internal",
		foreign: "Foreign",
		addCounterparties: {
			header: "New contractor",
			type: "Contractor type",
			internal: "Internal",
			foreign: "Foreign",
			name: "Contractor name",
			bank: "Bank",
			swift: "SWIFT - code",
			swiftBank: "SWIFT - code of Intermediary’s bank",
			recipientSwiftBank: "SWIFT - partner bank code",
			additionalInfo: "Additional information",
			counterContract: "Contractor’s country",
			save: "Save contractor",
			inn: "TIN of counterparty",
			mfoBank: "Bank code of the counterparty bank",
			nameText: "Name",
			modal: {
				title: "Cancellation",
				textCreate: "Are you sure you want to cancel partner creation?",
				textEdit: "Are you sure you want to cancel the partner change?",
				textPayment: "Are you sure you want to cancel the payment?",
				complete: "Yes",
				not: 'No'
			}
		},
		modalDelete: {
			title: "Deleting a partner",
			text: "Are you sure you want to delete the partner?"
		}
	},
	cardIndex: {
		header: "Payment pending file",
		docNumber: "Document number",
		organDebt: "Organization issuing debt",
		remainingSum: "Remaining sum",
		initSum: "Initial sum",
		totalDebt: "Total debt:"
	},
	sendingSwift: {
		header: "Sending SWIFT",
		typeTransaction: "Transaction type",
		typeMessage: "Message type",
		senderBank: "Senderʼs bank",
		senderCountry: "Sender’s country",
		selectBox: "Select a box A/D",
		accountBank: "Account in middleman’s bank",
		beneficiaryBank: "Beneficiary’s bank",
		beneficiaryBankName: "Beneficiary bank name",
		senderBankName: "Name of the sender's bank",
		beneficiaryCountry: "Beneficiary’s bank country",
		beneficiaryBikBank: "Beneficiary’s bank BIK",
		beneficiaryKorAccountBank: "Correspondent account in the Central Bank of RF",
		interBank: "Intermediary bank",
		interBankName: "Intermediary bank name",
		interBankCountry: "Intermediary bank country",
		interBikBank: "Intermediary’s bank BIK",
		interKorAccountBank: "Correspondent account with the Central Bank of the Russian Federation of the intermediary bank",
		interInn: "Recipient’s TIN",
		clientINN: "Sender's TIN",
		interKpp: "Recipient’s ICR",
		interMfo: "Sender's \"MFO\"",
		codeOperation: "Transaction code",
		nameOperation: "Name of transaction",
		selectOptions: "Option selection",
		idn: "ID of contract",
		address: "Address",
		city: "City",
		msg: "Indicate purpose of payment (goods or services), number and date of the contract. If the text does not fit, you can continue filling in the “Additional payment details” menu.",
		nds: "Including VAT",
		dontNds: "Excluding VAT",
		field: "Field",
		number: "Number",
		typeContract: "Contract type",
		notFoundReferenceBook: "No codes found in the code book",
	},
	reports: {
		header: "Reports",
		reportType: "Report type",
		date: "Date",
		sort: "Sorting",
		btnReset: "Reset",
		terminalNumbers: "Terminal numbers",
		paymentSystem: "Select payment system",
		selectByTerminal: "Select by terminal",
		selectByAllTerminals: "Select by all terminals",
		selectBySpecificTerminal: "Select by specific terminal",
		terminalReports: "Reports by terminals (xlsx)",
		paymentSystemErrorText: "Sorry, no terminals found",
		type: {
			text1: "Account statement for the date (excel)",
			text2: "Payment documents for the period (excel)",
			text3: "Account statement for the period (excel)",
			text4: "Statement of the posted documents for period (excel)",
			text5: "Account statement for the period (excel)",
			text6: "Balance-turnover statement for the period (excel)",
			text7: "Card index statement as of the date (excel)",
			text8: "Personal account statement for the period (excel)",
			text9: "Personal account statement for the period, advanced (excel)"
		},
		sorts: {
			number: "By document number",
			credit: "By credit turnover",
			debit: "By debit turnover"
		},
		turnovers: {
			title: 'Turnovers',
			all: 'All',
			debit: 'Debit',
			credit: 'Credit'
		}
	},
	selectAll: "Select all",
	transactHistory: {
		header: "Statement",
		format: "File format",
		period: "Period",
		selectPeriod: "Select period",
		upload: "Upload",
		outbox: "Outbox",
		filters: "Filters",
		account: "Account",
		selectAccount: "Select account",
		year: "Year",
		month: "Month",
		months: "Months",
		months4: "Months",
		week: "Week",
		yesterday: "Yesterday",
		day: "Day",
		hour: "Hour",
		status: "Status",
		approval: "for approval",
		cancel: "canceled",
		btnApply: "Apply",
		btnReset: "Reset all",
		replenishment: "Replenishment",
		write: "Write off",
		payOrder: "Payment order number",
		receipt: "Receipt",
		getReceipt: "Get a statement",
		repeat: "Repeat",
		templates: "To templates",
		addTemplates: "Add templates",
		nameCompany: "Company name",
		paymentStatuses: {
			text1: "Undefined",
			text2: "Entered",
			text3: "Authorized",
			text4: "Approved",
			text5: "Deleted",
			text6: "Rejected",
			text7: "Rejected",
			text8: "Hold over",
			text9: "Sent to the settlement center",
			text10: "Sent to Head office",
			text11: "Bank processing",
			text12: "Signature is not correct",
			text13: "Submitted for revision",
			text14: "Sending to the Bank",
			DELETED_BY_ACCOUNTANT: "Canceled",
			ON_ACCOUNTANT_LIST: "To be approved",
			ON_PROCESSING_LIST: "В ожидании",
			BANK_TREATMENT: "Отправлен в Банк",
			CANCELLED_BY_ACCOUNTANT: 'Canceled by accountant',
			CANCELLED_BY_DIRECTOR: 'Canceled by director',
			partiallyApproved: 'Partially approved',
			unsent: 'Unsent',
			DRAFT: 'Draft',
			UNDEFINED: 'Undefined',
			REJECTED_TCR: 'Rejected by settlement center',
		},
		client: "client",
		debitAccount: "Payer’s debit account",
		amount: "Amount",
		recipientCreditAccount: "Recipient’s credit account",
		amountWords: "Amount in words",
		bankCode: "Bank code",
		recipientBankCode: "Recipient bank code",
		done: "Done",
		nameDoc: "Document name",
		respondingClerk: "Executor",
		namePayers: "Payer’s name"
	},
	moduleCredit: {
		header: "Modular credit",
		title: "Get credit for any purposes fast and easy",
		btn: "Make an application",
		titleCondition: "Credit conditions",
		creditSize: "Credit size",
		rate: "Annual rate",
		creditPeriod: "Credit period",
		termReceipt: "Term of receipt",
		security: "Security",
		text: "Funds will be sent to the customer’s current account",
		checkboxText1: "I agree to the terms of",
		checkboxText2: "the Public Offer",
		desiredCredit: "Desired credit limit",
		confirmCredit: "Confirm credit conditions",
		btnClose: "Do not confirm",
		btnGood: "Confirm",
		creditApproved: {
			text: "A credit was approved for you on the following conditions:",
			approvedMount: "Approved amount:",
			duration: "Duration:",
			interestRate: "Interest rate:",
			confirmText: "For consent and further proccessing, you need to Confirm the application until {0}",
			btnDeny: "Deny",
			btnConfirm: "Confirm"
		},
		unfortunately: {
			text: "Unfortunately, the modular credit service is not available for you.",
			otherText: "To get a modular credit, you need to open a primary account within JSCB \"InfinBank”",
			btn: "Main page",
			notScoring: "Unfortunately, you did not pass the scoring check, and due to this modular credit service is not available for you.",
			notScoringInfo: "You can refer to any branch of InfinBank for obtaining a loan under the established procedure."
		},
		inProgress: {
			text: "Your application for a modular credit is being processed. Expect a response via a notification in the app, your request will be reviewed shortly."
		},
		settings: {
			loanAmount: "from 25 million before 1 billion",
			annualRate: "22,99%",
			creditTerm: "90 days",
			loanTerm: "from 1 before 2 days",
			security: "Not required"
		},
		days: "{0} days",
		enrollment: "Deposit",
		status: {
			PENDING: "Your application for a modular loan is pending. Please wait for an answer; it will be considered in the near future, you will be notified in the application.",
			UNAVAILABLE: [
				"Unfortunately, the Modular loan service is not available for you.",
				"To obtain a modular loan, you need to open a primary account at InfinBANK"
			],
			REJECTED: [
				"Unfortunately, you did not pass the scoring check; therefore the Modular loan service is not available for you. You can submit a new application after {0} days.",
				"You can apply to any branch of the JSCB InfinBANK for a loan according to the established procedure."
			],
			TO_SUPPORT: "An error occurred while processing your application.<br>Please call the contact center using following phone number: +998 (71) 202-50-80",
			END_TERM_SLA: "Your modular loan application has expired",
			CANCELLED: "You have denied to receive a modular loan.",
			K2_APPROVED_RESULT: "When status of Card Index 2 is rechecked, no ny debt found and your application has been sent for crediting funds to your current account. Please wait.",
			WAITING_FOR_K2_CHECK: "Checking arrears on Card Index 2. Wait for a response.",
			WAITING_FOR_LIMIT: "Your application has been sent to credit funds to your current account. Please wait.",
			COMPLETED: "Your funds have been successfully credited to your current account",
			WAITING_FOR_K2: [
				"To check debt status on the Card Index 2, press Checking K2 button",
				"Re-check Card Index 2"
			],
			K2_DETECTED: [
				"As of the current date, you have a debt in the amount of {0} UZS according to Card Index 2.",
				"When you click the Confirm button, the funds will be credited to your account.",
				"When you press the Cancel button, the bank will await for the full repayment of the card index for the subsequent issuance of a loan.",
				"You are required to make a decision until {0}."
			]
		}
	},
	notification: {
		header: "Notification!",
		news: "News",
		history: "Login history",
		btnDetails: "Details",
		operation: 'Operations',
		newsAndOffers: ' News and offers'
	},
	publicOffer: {
		header: "Public offer",
		text: "This offer has been developed in order to conclude an agreement between the Joint-Stock Commercial Bank \"Invest Finance Bank\" with the participation of foreign capital (hereinafter referred to as the Bank) on the one hand, and a legal entity or individual entrepreneur - recipient of a modular loan (business overdraft) (hereinafter referred to as the Credit) through remote banking systems (RBS) (hereinafter referred to as the Borrower) on the other hand.",
		titleAkb: 'JSCB "InfinBANK" Public Offer',
		instruction: 'Instruction manual'
	},
	saleCurrency: {
		header: "Sale of currency",
		selectCur: "Select currency",
		senderNumber: "Senderʼs account number",
		requestAmount: "Request amount",
		minRate: "Minimum rate",
		btbSend: "Send"
	},
	setting: {
		title: "Name of company",
		main: "Main",
		security: "Security",
		other: "Other",
		lang: "Language",
		save: "Save",
		offer: "Offer",
		header: "Security setting",
		change: "Change password",
		current: "Current password",
		new: "New password",
		confirmNew: "Confirm new password",
		changePasswordGoToBranch: "You have entered the wrong password more than 10 times. To change the password, we ask you to contact the bank branch with an identity document",
		passwordIsntEqual: "Passwords do not match, please try again",
		incorrectPassword: "Wrong password",
		incorrectPasswordValidate: "The password must consist of 8 Latin characters, contain numbers, at least 1 uppercase letter, at least 1 lowercase letter.",
		password: {
			title: "Password must consist of:",
			min: "total number of characters - 8",
			number: "Availability of numbers",
			letter: "The presence of letters in the Latin alphabet",
			minUpperLetter: "Have at least 1 uppercase letter",
			minLowerLetter: "Have at least 1 lowercase letter",
			other: "Be careful not to share your password with anyone."
		},
		activeSession: {
			title: "Active sessions",
			current: "Current session",
			completeSessions: "Terminate other sessions",
			online: "Online",
			textChange: "To terminate the session, click the top button \"Edit”",
			complete: "Done"
		}
	},
	services: {
		url2: "View card index",
		title1: "Credits",
		title2: "Deposits"
	},
	support: {
		header: "Support",
		title: "Hello, how can I help you?",
		telegram: "Ask question in Telegram bot",
		openTelegram: "Open application",
		phone: "Call",
		social: "Social networks"
	},
	draft: {
		header: "Draft",
		changeStatus: "Changing status:",
		edit: "Edit",
		paymentRecipient: "Payment recipient",
		recipientBy: "Received by: ",
		mfo: "Branch’s Bank code",
		title1: "Sums",
		title2: "Foreign currency",
		payment: "payment"
	},
	approval: {
		idDoc: "ID document",
		paymentCommission: "Fees",
		selectPayments: "Select payments to sign",
		signAll: "Approve all",
		sign: "For signing",
		sign2: "Sign"
	},
	emptyStatuses: {
		header: "The list is empty",
		text: "No information on your request",
		emptyTransactions: 'No transactions during the specified period'
	},
	role: {
		employee: "Employee",
		accountant: "Accountant",
		director: "Director"
	},
	roleInfo: {
		employee: "The Employee has the right to view and enter payment and other documents, without the possibility of sending payment documents to the Bank for execution.",
		accountant: "The Accountant has the right to enter, to send for signature to the Director and to view payment and other documents, as well as to receive various reports, but without the possibility of sending payment documents to the Bank for execution.",
		director: "The Director has full access to the “InfinBusiness”, including viewing, entering and sending payment documents and other documents to the Bank."
	},
	weekDays: {
		1: "mon",
		2: "tue",
		3: "wed",
		4: "thu",
		5: "fri",
		6: "sat",
		7: "sun"
	},
	choose: "Choose",
	common: {
		attention: "Attention"
	},
	number: [
		["one", "one", "Zero"],
		["two", "two"],
		["three"],
		["four"],
		["five"],
		["six"],
		["seven"],
		["eight"],
		["nine"],
		["ten"],
		["eleven"],
		["twelve"],
		["thirteen"],
		["fourteen"],
		["fifteen"],
		["sixteen"],
		["seventeen"],
		["eighteen"],
		["nineteen"],
		["twenty"],
		["thirty"],
		["forty"],
		["fifty"],
		["sixty"],
		["seventy"],
		["eighty"],
		["ninety"],
		["hundred"],
		["two hundred"],
		["three hundred"],
		["four hundred"],
		["five hundred"],
		["six hundred"],
		["seven hundred"],
		["eight hundred"],
		["nine hundreds"],
		["thousand"],
		["thousand"],
		["thousand"],
		["million"],
		["million"],
		["million"],
		["billion"],
		["billion"],
		["billion"],
		["trillions"],
		["trillion"],
		["trillion"]
	],
	currency: {
		cent: {
			RUB: ["kopeck", "kopeck", "kopeck"],
			USD: ["cents", "cent", "cents"],
			EUR: ["euro cent", "euro cent", "euro cent"],
			UZS: ["tiyin", "tiyin", "tiyin"]
		},
		self: {
			RUB: ["rubles", "ruble", "ruble"],
			USD: ["US dollars", "US dollars", "US dollars"],
			EUR: ["euro", "euro", "euro"],
			UZS: ["soum", "soum", "soum", "soum"]
		}
	},
	month: [
		["january"],
		["february"],
		["march"],
		["april"],
		["may"],
		["june"],
		["july"],
		["august"],
		["september"],
		["october"],
		["november"],
		["december"]
	],
	date: {
		yearShort: "y."
	},
	validate: {
		numberCard: "You can only top up your companyʼs cards. Check the recipientʼs account number"
	},
	emptyBlock: {
		accounts: {
			title: "You have no accounts",
			text: "To select an account,  you are required first to apply for its registration"
		},
		cards: {
			title: "You do not have corporate cards",
			text: "To select cards, you must submit an application for issue"
		},
		companyAccounts: {
			title: "Select a product",
			text: "The details of your card, account, loan or deposit will show here, select one of the products to view information"
		},
		later: {
			title: "Try again later",
			text: "Closing the transcation day is in progress."
		},
		contragent: {
			title: "The list of partners is empty",
			text: "Additional text"
		},
		contragent2: {
			title: "Add a partner",
			text: "After adding a partner, select it from the list on the left, all detailed information will be displayed here."
		},
		employees: {
			title: "Select an employee",
			text: "Your employee details will show here, select one of the employees to view information"
		}
	},
	form: {
		fill: "Please fill in this field",
		payrollPurpose: 'Please enter at least {0} characters in the "Payment Details" field, you have entered {1}'
	},
	modalTemplate: {
		title: "Enter the name",
		deleteTitle: "Deleting a template",
		deleteText: "Are you sure you delete this template"
	},
	statuses: {
		titleDeleteDraft: "Select a draft to delete",
		textSelected: "Delete selected"
	},
	eimzo: {
		titleSelected: "Select a key",
		errorCAPIWS: "E-IMZO Connection error. Maybe you do not have the E-IMZO module or the E-IMZO Browser installed.",
		errorBrowserWS: "The browser does not support WebSocket technology. Please install the latest browser version.",
		errorUpdateApp: "ATTENTION !!! Install new version of E-IMZO App or E-IMZO Browser.",
		errorDownloadEimzo: "Download E-IMZO software",
		errorDownloaded: "Loading",
		errorWrongPassword: "Invalid password"
	},
	crk: {
		titleModal: 'CC EDS',
		titleSelected: 'Choose a key',
		deadline: 'Deadline',
		expired: 'expired',
		errorWrongPassword: 'Wrong password',
		errorCrk: 'Failed to establish connection to CC EDS',
		errorKeyCrk: 'Key not found!',
		errorApp: 'The CC EDS module is not connected. Install the module.',
		errorConfirmCrk: 'An error occurred while signing in the EDS CA',
		errorDefault: 'An error occurred while checking the EDS. Repeat the operation later or contact the Bank.',
		errorKeyNotFound: 'The EDS key was not detected. Check the connection of the USB key to the computer.',
		downloadModule: 'Download the module'
	},
	forex: {
		countryName: 'Country name',
		title: 'Currency operations',
		buyCurrency: 'Purchase of currency',
		sellCurrency: 'Sale of currency',
		create: 'Create an Application',
		appWillLost: 'Application data will be lost',
		appAndFilesWillLost: 'Application data and attached files will be lost',
		replaceFilePrevent: 'Only one file can be attached to the application',
		replace: 'Replace',
		uz: 'Uzbekistan',
		day: 'Application date',
		buy: 'Buy',
		sell: 'Sale',
		sendToAccountant: 'Your application for the amount  {0} from {1} has been successfully sent to the accountant',
		sendToDirector: 'Your application for the amount of {0} from {1} has been successfully sent to the director',
		sendToBank: 'Your application for the amount {0} from {1} has been successfully sent to the bank',
		saveUpdates: 'Save changes',
		confirmDeleteDraft: 'Do you want to delete a draft?',
		enterTemplateName: 'Enter template name',
		existTemplateName: 'A template with the specified name already exists',
		templateName: 'Template name',
		deleteTemplate: 'Delete Template',
		confirmDeleteTemplate: 'Do you want to delete a template?',
		applicationNumber: 'Application No.',
		enterApplicationNumber: 'Enter Application No.',
		status: {
			ON_ACCOUNTANT_LIST: 'Approved by an accountant',
			ON_DIRECTOR_LIST: 'To be approved by the director',
			DELETED_BY_ACCOUNTANT: 'Removed by accountant',
			DELETED_BY_DIRECTOR: 'Removed by director',
			ON_PROCESSING_LIST: 'Sent to the bank',
			INTRODUCED: 'Entered',
			BANK_REVIEW: 'Under review at the bank',
			CONFIRMED: 'Confirmed',
			CONDUCTED_GO: 'Conducted in Head office',
			CONDUCTED_BRANCH: 'Held in the Branch',
			REJECTED: 'Declined',
			DELETED: 'Deleted',
			CREATED: 'Created',
			BANK_TREATMENT: 'Sent to bank',
		},
		downloadPdf: 'Download in .pdf format',
		toTemplate: 'To templates',
		approvalDelete: {
			deleteOne: 'Do you want to delete the application?',
			deleteFour: 'Do you want to delete {0} order items?',
			deleteFive: 'Do you want to delete {0} order items?',
		},
		confirmAndSend: 'Confirm and send',
		payments: 'Payments',
		applications: 'Applications',
		purpose_CODE_011: '<ol><li>The decision of the founders on the distribution of profits;</li><li>Conclusion of an audit firm or tax authority;</li><li>Calculation of funds for conversion.</li></ol>',
		purpose_CODE_012: '<ol><li>Copy of the secondment order;</li><li>Calculation of the amount in foreign currency;</li><li>Copy of the decision of the Cabinet of Ministers (if available).</li></ol>',
		purpose_CODE_014: '<ol><li>Original confirmation of the clearing house;</li><li>A copy of the agreement concluded between the broker (investment intermediary) and a non-resident - legal entity for the provision of brokerage services</li></ol>',
		accountVerifyingError: {
			WRONG_DATE: 'At this time, the application cannot be sent to the bank, as the calendar date does not coincide with the banking day.',
			RATE_CHANGED: 'Attention! The exchange rate has changed',
			FUNDS_LACK: 'Insufficient funds to complete the transaction for this amount {0}',
			CONTRACT_NOT_ACTIVE: 'The contract has expired. Please make changes',
			FUNDS_LACK_SELL: '{2} {1} is not enough on the debit account to make transactions in the amount of {0} {1}',
		},
		rateChanged: 'Initial course: {0} UZS<br>Current exchange rate: {1} UZS<br>In national currency equivalent: {2} UZS',
		openReceiverAccount: 'To carry out the operation, you need to open special accounts for conversion',
		refillAccountBySendingPayment: 'For your application, there is not enough coverage for the amount of {0} UZS. Create and send a payment to the bank?',
		paymentOrderDetails: 'Blocking funds for conversion under contract No. {0} from {1}',
		paymentOrderOnlyDetails: 'Blocking funds for conversion under contract',
		toFullCompletion: 'Until full completion',
		course: 'Application rate',
		courseAvailable: 'The rate is valid for the current date',
		uzsEquivalent: 'Equivalent in national currency',
		purpose: 'Purpose of purchase',
		idnNumber: 'Foreign trade contract number',
		idnDate: 'Contract date',
		idnCountry: 'Foreign partner country',
		phone: 'Customer phone',
		additional: 'Additionally',
		serviceType: 'Type of service',
		shortPurposeDesc: 'Brief description of the goal',
		account: 'Customer\'s account',
		reservingAccount: 'Reservation Account',
		loanAccount: 'Account for loan repayment ',
		receiverAccount: 'Special account in foreign currency',
		contractEndDate: 'Contract duration',
		partnerName: 'Name of foreign partner',
		contractAmount: 'Contract amount',
		purposeItems: {
			CODE_001: 'Equipment, accessories and spare parts',
			CODE_002: 'Raw materials',
			CODE_003: 'Services',
			CODE_004: 'Loans: Guaranteed by the Government',
			CODE_005: 'Loans: Not guaranteed by the Government',
			CODE_006: 'To repay a service loan',
			CODE_007: 'Leasing payments',
			CODE_008: 'Medicines, medicines and medical devices',
			CODE_009: 'Cars',
			CODE_010: 'Other consumer goods',
			CODE_011: 'For the repatriation of foreign income',
			CODE_012: 'Travel expenses',
			CODE_013: 'For other purposes',
			CODE_014: 'To transfer funds received from the sale of products at open electronic auctions of commodity exchanges',
		},
		transactionCode: 'Transaction code',
		fundsSource: 'Source of funds',
		currencyAccount: 'Foreign currency account',
		shortDesc: 'Brief description',
		buyTypeItems: {
			TRANSPORTATION: 'Transport services',
			CONSULTING: 'Consulting services',
			ADVERTISING: 'Advertising services',
			REPAIR: 'Repair services',
			COMMUNICATION: 'Communication services',
			INSURANCE: 'Insurance services',
			FINANCIAL: 'Financial services',
			ROYALTIES: 'Royalty',
			INFORMATION: 'Information Services',
			CONSTRUCTION: 'Construction services',
			OTHER: 'Other',
		},
		buyForeignCurrency: 'Buying foreign currency',
		sellForeignCurrency: 'Sell of foreign currency',
		exchange: 'Exchange of hard currency for hard currency',
		foundsSourceItems: {
			EXPORT_EARNINGS: 'Export earnings',
			LOANS_RECEIVED_FROM_DOMESTIC_BANK: 'Loans received from a domestic bank',
			LOANS_FROM_ABROAD: 'Loans received from abroad',
			REVERSE_SALE_UNUSED_CURRENCY: 'Reverse sale of unused currency',
			OTHER_REFERENCES: 'Other sources',
		},
		amountFrom: 'Amount from',
		amountTo: 'Amount up to',
		fileUploadRequired: 'File download is required',
	},
	modals: {
		anor: {
			modalConfirmTitle: "Choose the type of transfer",
			modalConfirmText: "Currently, the Central Bank's Settlement Center does not accept transfer requests. You can make a transfer via ANOR. Choose the transfer method:",
			btnAnor: "Via ANOR",
			btnCB: "Central Bank Settlement Center",
			btnLater: "Execute later"
		}
	},
	sessionExpired: 'You have not been active for too long. For security reasons, an automatic logout occurred. Please sign in again to continue.',
	openAccount: {
		enterPhoneNumber: 'Введите номер телефона',
		customerName: 'Укажите как к Вам обращаться',
		getCode: 'Получить код',
		confirmOffer: 'Нажимая «{0}», Вы принимаете и соглашаетесь с условиями <a href="{1}" target="_blank" class="link-primary">оферты</a>',
		inn: 'ИНН юридического лица',
		pinfl: 'ПИНФЛ юридического лица',
		fillApplication: 'Заполните заявку на оформление счёта',
		isIndividualEntrepreneur: 'Is your company an “IP"?',
		isIndividualEntrepreneurDescription: 'ИП - индивидуальным предпринимателем',
		openSecondaryAccount: 'Вы открываете вторичный счёт',
		companyName: 'Names of the organization',
		registerDate: 'Date of registration',
		registerEndDate: 'End date of registration',
		companyAddress: 'Organization\'s address',
		primaryAccountBank: 'Банк в котором открыт первичный счет',
		yourApplications: 'Your applications',
		status: {
			OPEN: 'Accepted by the Bank',
			DECLINED_BY_BANK: 'Rejected by the Bank',
			DECLINED_BY_CUSTOMER: 'Client\'s refusal',
			ACCOUNT_OPENED: 'Счет открыт',
			DONE: 'Done',
		},
		warnTheClient: 'Your application to open an account has been accepted. Our staff will contact you soon.',
		documentsNotProvided: 'Предоставлены не все необходимые документы',
		accountType: {
			PRIMARY_ACCOUNT: 'Первичный счет',
			SECONDARY_ACCOUNT: 'Вторичный счет'
		},
		aboutCompany: 'About the company',
		toMainPage: 'На главную сайта',
		legalEntityLoadingHintList: [
			'Ищем Ваши ранее оставленные заявки...',
			'Ищем среди клиентов...',
			'Проверяем информацию в службе Единого окна...',
			'Ищем Ваши счета в других банках...',
			'Сверяем данные...',
			'Осталось совсем немного подождать...',
		],
		organizationName: 'Наименование организации',
		initiatorPhone: 'Номер телефона инициатора заявки',
		innOrPinfl: 'Your NIT/PIN FL',
		applicationNumber: 'Application number',
		applicationDate: 'Дата заявки',
		selectedTariff: 'Selected tariff',
		accountTypeTitle: 'Account type',
		employeesCount: 'Number of employees with Internet banking access',
		branchNumber: 'MFO filial’s',
		assignedEmployee: 'An employee has been appointed',
		meetingAddress: 'Meeting address',
		bankEmployeePhone: 'Phone number of the bank employee',
		meetingDate: 'Date and time of the meeting',
		applyApplication: 'Подать заявку',
		application: 'Заявка на открытие счета',
		enterSmsCode: 'Введите код из СМС',
		codeSent: 'Код выслан на номер {0}',
		incorrectInn: 'Юридическое лицо с таким ИНН не существует. Проверьте корректность введенного ИНН',
		changePhone: 'Изменить телефон',
		getNewCode: 'Получить новый код можно через {0}:{1} сек.',
		end: 'Заполнение заявки завершено'
	},
	paymentRequirements: {
		incoming: 'Incoming payment requests',
		outgoing: 'Outgoing payment requests',
		familiarize: 'Review',
		offer: 'I confirm that I have familiarized myself with the payment requirements in the amount of {0} pcs. that are currently issued to {1}.<br><br>I understand that after confirming the fact that I have read the list of issued payment requirements, all payment requirements that are currently issued to {1} will be placed in the Card File 1.<br><br>I understand that after placing the requirements in the Card File 1, if I do not make a decision on payment or refusal payment for these requirements within 5 working days, they will be automatically executed or placed in the Card File 2 (in case no funds on the account for payment requirement).',
		requestsProcessed: 'Payment requests have been successfully processed',
		requestsProcessedDetails: 'From the {0} payment requirements, have been successfully processed and placed in the Card file 1 {1} of requirements. To pay or refuse payment requirements, you can go to the information viewing page of the Card File 1.',
		requestsProcessedHint: 'When moving to the Card File, your current operation will be saved in drafts.',
		sign: 'Introduction',
		requests: 'Payment requirements',
		request: 'Payment requirement',
		goToCardIndex: 'Go to the Card File {0}',
		incomingShort: 'Inbox',
		outgoingShort: 'Outbox',
		docDate: 'Document date',
		debtType: 'Type of debt',
		destCardIndexCode: 'The Card File assignment code',
		destCode: 'Payment destination code',
		toCompany: 'The organization that issued the request',
		fromCompany: 'The organization to which the payment was issued',
		pinfl: 'PIN FL',
		unprocessed: 'Not processed',
		processed: 'Processed',
		dueDate: 'The decision must be made before',
		daysLeft: {
			one: '{0} day left',
			fromTwoToFour: '{0} day left',
			fromFive: '{0} days left',
		},
		denie: 'Refuse',
		pay: 'Pay',
		denieTitle: 'Refusal',
		rejectionReason: 'Reason of rejection',
		create: 'Create a payment request',
		recall: 'Withdraw',
		createShort: 'Create',
		recallQuestion: 'Do you want to cancel payment request?',
		fundRecipient: 'Fund recipient',
		fundSender: 'Fund sender',
		withAcceptance: 'With acceptance',
		withoutAcceptance: 'Without acceptance',
	},
	attachments: 'Attachments',
	attachDocument: 'Attach the document',
	minLength: 'Minimum number of signs {0}',
	uploadFiles: 'Download the files',
	acceptedFileFormats: 'Format support: {0}',
	minAmount: 'Minimum amount {0}',
	hasUpdate: 'A new update has been released',
	update: 'Update',
	paymentsAndApplications: 'Payments and applications',
	minAmountOperation: 'The transaction amount cannot be less than {0}',
	innOrPinflInvalid: 'Enter 9 digits if the recipient is a legal entity, or 14 digits if the recipient is an individual entrepreneur',
	incorrectAccount: 'Incorrect account number entered',
	beforeInputMFO: 'Failed to verify account. Enter MFI',
	incorrectAccountOrMfo: 'Incorrect account or MFI number entered',
	reference: {
		branch: 'Search by MFI number and name',
		code: 'Code',
		codeDescription: 'Description of the file assignment code',
		debtDescription: 'Description of the type of debt',
		debt: 'Search for the type of debt',
		codeCardIndex: 'Search for the target code of the card index',
		purposeCode: 'Finding the payment purpose code',
		purposeDescription: 'Description of the payment purpose code',
	},
	needBankAccount: 'To process an outgoing payment request, it is necessary that the main account be opened with InFinBank',
	startSearch: 'Start searching',
	confirmActionWithSms: 'Confirm the action with an SMS code',
	alert: {
		browserError: 'Unfortunately, your browser is not supported. There may be problems in the operation of the application.',
		supportBrowser: 'Supported browsers',
		titleSupportBrowser: 'Supporting browsers',
		versionOld: 'Version {0} or newer'
	},
	revisionError: {
		title: 'The reason for returning for revision',
		allAmount: 'Total debt',
		deleteDocumnet: 'Deleting a document',
		deleteQuestion: 'Do you want to delete?'
	}
};
